// Operational product selection must use product identity, not raw row IDs:
// multi-site CSV exports can legitimately repeat the same SKU/row ID at every site.
const token = (value) => String(value ?? "").trim().toLowerCase().replace(/\s+/g, " ");

export function countProductSelectionKey(row = {}) {
  const sku = token(row.sku);
  const name = token(row.product);
  const category = token(row.category);
  // Do not use the raw row ID alone: it can recur across ten sites.
  return `${sku ? `sku:${sku}` : `id:${token(row.id)}`}|product:${name}|category:${category}`;
}

export function uniqueCountProducts(rows = []) {
  const seen = new Set();
  return (Array.isArray(rows) ? rows : []).filter((row) => {
    const key = countProductSelectionKey(row);
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}

export function selectedCountProducts(rows = [], keys = []) {
  const selected = new Set(keys);
  return uniqueCountProducts((Array.isArray(rows) ? rows : []).filter(
    (row) => selected.has(countProductSelectionKey(row)),
  ));
}
